import Vue from 'vue'
import VueRouter, { NavigationGuard, RouteConfig } from 'vue-router'
import routesBoard from '@board/router'
import routesHome from '@home/router'
import routesMail from '@mail/router'
import routesCalendar from '@calendar/router'
import routesContact from '@contact/router'
import routesWorkflow from '@workflow/router'
import routesAccount from '@account/router'
import routesOrgmap from '@orgmap/router'
import { PortalCacheGuard, multiguard, I18nGuard } from '@appbase/router'
import moduleAppbase from '@appbase/router'
import routesGnb from '@gnb/router'
import BaseLayout from '@/templates/BaseLayout/BaseLayout.vue';
import authGuard from '@account/router/auth-guard'
import store from '@/store'
const AppLoginView = () =>
    import(/* webpackChunkName: "account" */ '@/components/login/AppLoginView.vue')

Vue.use(VueRouter)

interface web2appPayload {
  group: string
  function: string
  args: any
}

const mailRoutes: string[] = ['mail-home', 'mail-list', 'contact-list']

const AppLoginGuard: NavigationGuard = (to, from, next) => {
  var current = store.state.$account?.current

  if (to.query.applogin && current) {
    //모바일앱 푸시를 위한 기기 사용자 등록 처리
    var web2appPayload: web2appPayload = {
      group: 'login',
      function: 'logined',
      args: {
          userId: current.user.id,
          topics: current.topics // 토픽 정보
      }
    };

    try {
      (window as any).dsmobileapp.web2app(web2appPayload.group, web2appPayload.function, web2appPayload.args);
    } catch (err) {
      console.log('err: ' + err + '\n\nuseragent:' + window.navigator.userAgent)
    }

    delete to.query["applogin"]

    next({
      name: to.name || '',
      query: to.query,
    })
    

  } else {
    next()
  }
}

const MailOnlyGuard: NavigationGuard = (to, from, next) => {
  var current = store.state.$account?.current
  if (current) {
    if (current.user.deptCode.indexOf('MAILONLY') > -1) {
      if (!mailRoutes.includes(to.name || '')) {
        next('/mail/home')
      } else {
        next()
      }
    } else {
      next()
    }
  } 
}

const routes: RouteConfig[] = [
  ...routesAccount,
 {
    path: '/',
    component: BaseLayout,
    beforeEnter: multiguard(
      [PortalCacheGuard, I18nGuard, AppLoginGuard, MailOnlyGuard],
      ['/account/login']
    ),
    children: [
      ...routesBoard,
      ...routesHome,
      ...routesMail,
      ...routesCalendar,
      ...routesContact,
      ...routesWorkflow,
      ...routesOrgmap,
      ...moduleAppbase,
      ...routesGnb,
      {
        path:'',
        redirect: 'home/main'
      },
      {
        path: 'login',
        component: AppLoginView
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(authGuard)

export default router
